import { Box, Confetti, Dialog } from '@branch-messenger/willow-ui'
import { useTheme } from 'styled-components'

import { useTakeAdvance } from '@/containers/onDemandPay/TakeAdvance/TakeAdvanceContext'
import { useBranchVerification } from '@/selectors/ewa'

import { TakeAdvanceButton } from '../styles'
import { TakeAdvanceContainer } from './styles'
import { TakeAdvanceHeader } from './TakeAdvanceHeader'
import { TakeAdvanceSteps } from './TakeAdvanceSteps'

export const TakeAdvanceModal = () => {
  const theme = useTheme()
  const { takeAdvanceValues, modalOpen, setModalOpen, close } = useTakeAdvance()

  const isSuccessful = !!takeAdvanceValues.transfer_id

  const {
    data: { limitReached, isInvalid },
  } = useBranchVerification()

  const advanceButtonDescription = limitReached
    ? 'Pay Period Limit Reached'
    : isInvalid
      ? 'Unable to Take Advance'
      : 'Take Advance'

  const openChanged = (open: boolean) => {
    if (!open) {
      close()
    } else {
      setModalOpen(open)
    }
  }

  return (
    <>
      {isSuccessful && (
        <Box
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            pointerEvents: 'none',
            zIndex: theme.zIndex.max,
          }}
        >
          <Confetti recycle={false} />
        </Box>
      )}
      <Dialog
        open={modalOpen}
        onOpenChange={openChanged}
        hideCloseButton
        trigger={
          <TakeAdvanceButton disabled={isInvalid} size="lg">
            {advanceButtonDescription}
          </TakeAdvanceButton>
        }
        size="sm"
      >
        <TakeAdvanceContainer>
          <TakeAdvanceHeader />
          <TakeAdvanceSteps />
        </TakeAdvanceContainer>
      </Dialog>
    </>
  )
}
